import { connect } from 'react-redux';
import { setOpenModal } from '../../../../../../store/modals/actions';
import { getModals } from '../../../../../../store/modals/selectors';
import ProductModal from './ProductModal';

const mapStateToProps = (state) => ({
  modals: getModals(state),
});

const mapDispatchToProps = (dispatch) => ({
  setOpenModal: (modal, value) => {
    dispatch(setOpenModal(modal, value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductModal);
